import HomePageAutocomplete from "app/pages/sales-intelligence/modules/company-autocomplete/components/HomePageAutocomplete/HomePageAutocomplete";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import homePageTrackingService from "app/pages/sales-intelligence/services/tracking/home-page/trackingService";
import { SearchType } from "app/pages/sales-intelligence/services/tracking/home-page/types";

const HomepageCompaniesSearch = () => {
    const handleCompanyClick = ({ key, companyName }: { key: string; companyName: string }) => {
        homePageTrackingService.trackCompanyClicked(companyName);
        void siNavigator.goToCompanyAnalysisOverviewPage(key);
    };

    const handleWebsiteClick = (domain: string) => {
        homePageTrackingService.trackDomainClicked(SearchType.New, domain);
        void siNavigator.goToWebsiteAnalysisPerformancePage({
            key: domain,
            isWWW: "*",
            duration: "3m",
            country: 999,
        });
    };

    const handleItemClick = (domain: string, isCompanyLevel: boolean) => {
        if (isCompanyLevel) {
            handleCompanyClick({ key: domain, companyName: domain });
        } else {
            handleWebsiteClick(domain);
        }
    };

    return <HomePageAutocomplete onItemClick={handleItemClick} />;
};

export default HomepageCompaniesSearch;
